import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WaitlistForm = ({ compact = false }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | done
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("loading");
    try {
      const { data } = await axios.post(`${API}/waitlist`, { email });
      setState("done");
      setMessage(
        data.status === "already_registered"
          ? "ALREADY_IN_QUEUE // ACCESS REQUEST ON FILE"
          : "ACCESS_REQUEST_LOGGED // YOU ARE IN THE QUEUE"
      );
    } catch (err) {
      setState("idle");
      toast.error("Transmission failed. Retry.", {
        description: err?.response?.data?.detail?.[0]?.msg || "Network error",
      });
    }
  };

  if (state === "done") {
    return (
      <div
        data-testid="waitlist-success"
        className="border border-[#ff3366] bg-[#111] px-4 py-3 text-[11px] text-[#ff3366] font-bold tracking-widest max-w-md mb-6"
      >
        [+] {message}
      </div>
    );
  }

  return (
    <form
      data-testid={compact ? "waitlist-form-footer" : "waitlist-form"}
      onSubmit={submit}
      className="flex flex-col sm:flex-row gap-2 max-w-md mb-6"
    >
      <input
        data-testid={compact ? "waitlist-email-input-footer" : "waitlist-email-input"}
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="root@domain.com"
        className="bg-[#111] border border-[#333] px-4 py-2.5 text-xs text-white placeholder:text-[#555] focus:outline-none focus:border-[#ff3366] flex-1 transition-colors"
      />
      <button
        data-testid={compact ? "waitlist-submit-footer" : "waitlist-submit"}
        type="submit"
        disabled={state === "loading"}
        className="bg-[#ff3366] text-black font-bold text-xs uppercase px-5 py-2.5 hover:bg-white transition-colors disabled:opacity-50"
      >
        {state === "loading" ? "Transmitting…" : "Join Waitlist"}
      </button>
    </form>
  );
};
